export default __webpack_public_path__ + "static/6-9fdb5ff935e96d8dc943fb7be818e96d.webp";